module.exports = __webpack_public_path__ + "img/49ne.4f4bb018.svg";